const { apiRequest } = require("./apiService");

export const sendMessageToGPT = async (inputMessage) => {
  try {
    const data = await apiRequest("/openai/send-message", "POST", {
      inputMessage,
    });
    console.log("API Response:", data);
    return data?.output || null;
  } catch (error) {
    console.error("sendMessageToGPT Error:", error.message);
    return null;
  }
};
